import { useDraggable } from "@dnd-kit/core";

export const AutoRuleTile = ({ id, name, classes, isOverlay = false }) => {
  const { attributes, listeners, setNodeRef } = useDraggable({
    id: id,
    data: {
      id,
      name,
    },
  });

  const style = isOverlay
    ? {
        backgroundColor: "#fff",
        border: "1px solid #d1e4e8",
        boxShadow: "0 6px 20px rgba(0, 0, 0, 0.15)",
        transform: "scale(1.05)",
        cursor: "grabbing",
        opacity: 0.95,
        pointerEvents: "none",
      }
    : {};
  return (
    <div
      ref={setNodeRef}
      style={style}
      {...listeners}
      {...attributes}
      className={classes}
    >
      <span>{name}</span>
    </div>
  );
};
